import styled from 'styled-components';

export const Container = styled.div`
    padding: 12px 16px 40px;
    max-width: 720px;
    margin: 0 auto;
`;

export const Desc = styled.div`
    font-size: 12px;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 14px;
    background: #f8fafc;
    border: 1px solid #eef2f7;
    border-radius: 10px;
    padding: 12px;

    b { color: #334155; }
`;

export const Toolbar = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;

    .searchWrap {
        position: relative;
        display: flex;
        align-items: center;
    }
    .searchWrap input {
        width: 100%;
        height: 44px;
        padding: 0 40px 0 14px;
        border: 1px solid #cbd5e1;
        border-radius: 10px;
        /* iOS 확대 방지 */
        font-size: 16px;
        box-sizing: border-box;
        background: #f8fafc;
    }
    .searchWrap input:focus {
        outline: none;
        border-color: #2563eb;
        background: #fff;
    }
    .searchWrap .clear {
        position: absolute;
        right: 6px;
        width: 30px; height: 30px;
        border: none;
        background: #e2e8f0;
        color: #475569;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;
    }

    .toolbarMeta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        padding: 0 2px;
    }
    .toolbarMeta .count { color: #475569; font-weight: 600; }
    .toolbarMeta .foldActions {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #94a3b8;
    }
    .toolbarMeta .foldActions button {
        border: none;
        background: transparent;
        color: #2563eb;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        padding: 2px;
    }
`;

export const RuleList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const RuleCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;

    &.expanded {
        border-color: #bfdbfe;
        box-shadow: 0 1px 3px rgba(37, 99, 235, 0.08);
    }

    /* 요약 행 (항상 노출) */
    .summaryRow {
        display: flex;
        align-items: center;
    }
    .summaryToggle {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
        height: 52px;
        padding: 0 4px 0 12px;
        border: none;
        background: transparent;
        text-align: left;
        cursor: pointer;
    }
    .summaryToggle .caret {
        flex-shrink: 0;
        width: 16px;
        color: #64748b;
        font-size: 12px;
    }
    .summaryToggle .summaryName {
        flex: 1;
        min-width: 0;
        font-size: 15px;
        font-weight: 600;
        color: #0f172a;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .summaryToggle .summaryName .noName { color: #94a3b8; font-weight: 500; font-style: normal; }
    .summaryToggle .summaryMeta {
        flex-shrink: 0;
        font-size: 12px;
        color: #64748b;
        background: #f1f5f9;
        border-radius: 999px;
        padding: 3px 10px;
    }
    .summaryRow .deleteRule {
        flex-shrink: 0;
        width: 44px;
        height: 52px;
        border: none;
        background: transparent;
        color: #e11d48;
        font-size: 15px;
        cursor: pointer;
    }

    /* 펼친 편집 영역 */
    .ruleBody {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 4px 14px 14px;
        border-top: 1px solid #eef2f7;
    }
    .ruleBody input.name {
        width: 100%;
        height: 42px;
        padding: 0 12px;
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 600;
        box-sizing: border-box;
    }

    .boxRow {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: #334155;
    }
    .boxRow input {
        width: 96px;
        height: 40px;
        padding: 0 10px;
        border: 1px solid #cbd5e1;
        border-radius: 8px;
        font-size: 15px;
        text-align: right;
    }
    .boxRow .unit { color: #64748b; }
`;

export const Conditions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    .condHeader {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }
    .condEmpty {
        font-size: 12px;
        color: #94a3b8;
        padding: 4px 2px;
    }

    /* 조건 상품이 많아도 세로로 길어지지 않게 칩을 가로로 흘려 배치 */
    .chipGrid {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }

    .chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        max-width: 100%;
        background: #f1f5f9;
        border: 1px solid #e2e8f0;
        border-radius: 999px;
        padding: 3px 5px 3px 3px;
    }

    /* 같은 상품의 다른 옵션 전체 추가 */
    .chip .chipSibling {
        flex-shrink: 0;
        width: 22px; height: 22px;
        border: none;
        background: #dbeafe;
        color: #2563eb;
        border-radius: 50%;
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .chip .chipSibling:hover { background: #bfdbfe; }

    .chip .chipLabel {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        min-width: 0;
        font-size: 12px;
    }
    .chip .chipName {
        font-weight: 600;
        color: #0f172a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 140px;
    }
    .chip .chipOpt {
        color: #475569;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
    }
    .chip .chipCode {
        font-family: monospace;
        font-size: 11px;
        color: #2563eb;
        background: #eff6ff;
        border-radius: 4px;
        padding: 0 4px;
        white-space: nowrap;
    }

    /* 같은 상품에 속한 옵션이 2개 이상일 때만 노출 — 연관 옵션 일괄 제거 */
    .chip .chipSiblingRemove {
        flex-shrink: 0;
        width: 22px; height: 22px;
        border: none;
        background: #fee2e2;
        color: #dc2626;
        border-radius: 50%;
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    .chip .chipSiblingRemove:hover { background: #fecaca; }

    .chip .chipRemove {
        flex-shrink: 0;
        width: 20px; height: 20px;
        border: none;
        background: transparent;
        color: #94a3b8;
        border-radius: 50%;
        font-size: 12px;
        line-height: 1;
        cursor: pointer;
    }
    .chip .chipRemove:hover { background: #e2e8f0; color: #475569; }

    .chipAdd {
        display: inline-flex;
        align-items: center;
        height: 30px;
        padding: 0 14px;
        border: 1px dashed #93c5fd;
        background: #eff6ff;
        color: #2563eb;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
    }
`;

export const AddRuleButton = styled.button`
    width: 100%;
    height: 50px;
    margin-top: 14px;
    border: 1px dashed #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
`;

export const Footer = styled.div`
    position: sticky;
    bottom: 0;
    margin-top: 16px;
    padding-top: 12px;
    background: linear-gradient(to top, #fff 70%, transparent);

    button {
        width: 100%;
        height: 50px;
    }
`;

export const Empty = styled.div`
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
    padding: 28px 0;
`;
